function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 73 73"
}, props), React.createElement("circle", {
  cx: "36.272",
  cy: "36.435",
  r: "35.798",
  fill: "#fff"
}), React.createElement("path", {
  d: "M36.272 12.795c-13.056 0-23.64 10.584-23.64 23.64 0 13.057 10.584 23.64 23.64 23.64 13.057 0 23.64-10.583 23.64-23.64 0-13.056-10.583-23.64-23.64-23.64zm-5.787 33.439h-4.787V30.828h4.787v15.406zm-2.423-17.297c-1.512 0-2.49-1.071-2.49-2.396 0-1.352 1.008-2.391 2.552-2.391s2.49 1.039 2.519 2.39c0 1.326-.975 2.397-2.58 2.397zM47.97 46.234h-4.787v-8.538c0-1.987-.694-3.337-2.425-3.337-1.323 0-2.108.914-2.456 1.793-.128.313-.16.756-.16 1.197v8.882h-4.79v-10.49c0-1.923-.06-3.531-.125-4.915h4.16l.218 2.14h.096c.63-1.005 2.175-2.488 4.758-2.488 3.15 0 5.511 2.11 5.511 6.647v9.109z",
  fill: "#59A3BD"
})));